const config = {
  rpcUrl: "https://granadanet.smartpy.io",
  tokenAddress: "KT1HrjGaoTmdZ8Znbup6bgV2gEpFF8tt9jo5",
  tokenDecimals: 10 ** 6,
  tokenBalanceBigMapId: 87342,
  dexAddress: "KT1FFoWsyFH7rJGxogvPRRuu8MwskY6Asags",
  lpTokenAddress: "KT1AEd7ZCSdpZhNNnEwZU9sNFSkib2s7e61f",
  lpDecimals: 10 ** 9,
  lpBalanceBigMapId: 87352,
  preferredNetwork: "granadanet",
};

export default config;
